// Custom components
import SpiffsBonusTable from "./SpiffsBonusTable";
import TableLoader from "@/Layouts/components/Skeletons/TableLoader";
// Types
import { ISpiffsBonusTable } from "@/Washouts/types/commons";

export default function SpiffsBonus(props: Readonly<ISpiffsBonusTable>) {
	const { loading = false, dataPresent = false } = props;
	if (loading) {
		return <TableLoader smallTitle content sx={{ padding: "15px 10px 0px 10px" }} />;
	}

	return <>{dataPresent && <SpiffsBonusTable {...props} />}</>;
}
